<template>
  <div class="modal fade" :class="show ? 'show' : 'hide'" style="display: block; background-color: rgba(0,0,0,0.3)">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body row" style="height: 92%;">
          <div class="study-list col-4 h-100">
            <div class="study-wrapper" v-for="study in (data || [])" :key="study.id">
              <Checkbox
                class="study-selection-checkbox"
                :value="Boolean(selectedStudies[study.id])"
                @change="(value) => onStudySelectionChange(study.id, value)"
              >
                {{ study.project_name }}
              </Checkbox>
            </div>
          </div>
          <div class="edit-form-wrapper col-8 h-100">
            <div class="form-row row mt-3" v-for="(_, rowId) in formRows" :key="`edit-row-${rowId}`">
              <div class="col-5">
                <div class="input-wrapper">
                  <div class="d-flex">
                    <label>Field type</label>
                  </div>
                  <el-select v-model="form[rowId].key" placeholder="Select data" filterable @change="form[rowId].value = null">
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option v-for="type in filterTags()" :key="type.field"
                                 :label="type.label"
                                 :value="type.field">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </div>
              </div>
              <div class="col-5">
                <div class="input-wrapper">
                  <div class="d-flex">
                    <label>Field value</label>
                  </div>
                  <el-select
                      v-if="getFieldType(form[rowId].key) === 'category'"
                      v-model="form[rowId].value"
                      placeholder="Select data"
                      multiple
                      filterable
                      collapse-tags
                      required
                      allow-create
                      :disabled="!form[rowId].key">
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option v-for="value in getProductTypeOptionsForCategory(form[rowId].key)"
                        :key="value"
                        :label="value"
                        :value="value">
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input
                      v-else
                      placeholder="Value"
                      v-model="form[rowId].value"
                      required
                      clearable>
                  </el-input>
                </div>
              </div>
              <div class="col-2">
                <div class="d-flex flex-row justify-content-end align-items-center mr-2" style="margin-top: 21px;">
                  <button v-if="rowId === 0" class="btn btn-block btn-outline-success" @click="addRow"
                          style="width: 29px; height: 29px; margin-top: 0; padding: 0; border-radius: 4px;" type="button"><i
                      class="el-icon-plus"></i></button>
                  <button v-else class="btn btn-block btn-outline-danger" @click="removeRow(rowId)"
                          style="width: 29px; height: 29px; margin-top: 0; padding: 0; border-radius: 4px;" type="button"><i
                      class="el-icon-delete"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <b-alert
            :show="formError"
            variant="warning">
            Please fill all the form rows to save data
          </b-alert>
          <b-alert
            :show="selectionError"
            variant="warning">
            Please select at least one study
          </b-alert>
          <button class="btn btn-secondary" type="button" @click="closePopup">Cancel</button>
          <button class="btn btn-primary" :class="{disabled: false}" @click="edit" type="button">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import studyGetters from '../../store/modules/studies/getterTypes'
import studyActions from '../../store/modules/studies/actionTypes'
import Checkbox from '../shared/Checkbox'

export default {
  name: 'EditStudiesPopup',
  components: {
    Checkbox
  },
  props: {
    data: Array,
    dependencies: Array
  },
  data () {
    return {
      show: false,
      fields: [],
      formError: false,
      selectionError: false,
      selectedStudies: {},
      form: [
        { key: '', value: '' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      tags: studyGetters.GET_STUDY_DETAILS_TAGS
    }),
    formRows () {
      return this.form.length
    }
  },
  methods: {
    ...mapActions({
      editStudies: studyActions.EDIT_STUDIES,
      getUpdatedDropdownValues: studyActions.FETCH_STUDY_TAGS
    }),
    showPopup () {
      this.show = true
      this.formError = false
      this.selectionError = false
      this.initializeSelectedStudies()
    },
    closePopup () {
      this.show = false
      this.selectionError = false
    },
    addRow () {
      this.form.push(
        { key: '', value: '' }
      )
    },
    removeRow (index) {
      this.form.splice(index, 1)
    },
    initializeSelectedStudies () {
      const selectedStudies = {}
      ;(this.data || []).forEach(study => {
        if (study && typeof study.id !== 'undefined' && study.id !== null) {
          selectedStudies[study.id] = true
        }
      })
      this.selectedStudies = selectedStudies
    },
    onStudySelectionChange (studyId, value) {
      this.selectedStudies[studyId] = value
    },
    getSelectedStudyIds () {
      return (this.data || [])
        .filter(study => study && this.selectedStudies[study.id])
        .map(study => study.id)
    },
    getFieldType (field) {
      const fieldObj = this.tags ? this.tags.find(el => el.field === field) : null
      return fieldObj ? fieldObj.type : ''
    },
    async edit () {
      if (this.form.length > 1 && !this.form[0].key) {
        this.formError = true
      } else {
        this.formError = false
      }
      const selectedStudyIds = this.getSelectedStudyIds()
      if (!selectedStudyIds.length) {
        this.selectionError = true
        return
      }
      this.selectionError = false
      await this.editStudies({ studies: selectedStudyIds, data: this.form })
      this.$emit('edit')
      this.closePopup()
    },
    getOptionsForSelectedTag (tag) {
      const selectedTag = this.tags ? this.tags.find(el => el.field === tag) : []
      return selectedTag ? selectedTag.options : []
    },
    filterTags () {
      return this.tags ? this.tags.filter(el => el.type === 'category') : []
    },
    getProductTypeOptionsForCategory (tag) {
      let options = []

      if (this.dependencies.find(dependency => dependency.field === tag)) {
        this.dependencies[0].options.forEach(dependencyOption => {
          this.form.forEach(formItem => {
            if (formItem.value && formItem.value.find(formValueItem => formValueItem === dependencyOption.value)) {
              const newOptions = dependencyOption.options.filter(opt => !options.includes(opt))
              options = options.concat(newOptions)
            }
          })
        })
      }
      if (!options.length) {
        options = this.getOptionsForSelectedTag(tag)
      }
      return options
    }
  },
  watch: {
    data () {
      this.initializeSelectedStudies()
    }
  },
  async beforeMount () {
    this.tags || await this.getUpdatedDropdownValues()
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/variables";
.hide {
  height: 0;
}

.show {
  height: 100%;
}

.modal-dialog {
  height: calc(100% - 160px);
  margin-top: 80px;
  margin-bottom: 80px;
  max-width: 1200px;
  display: flex;
  .modal-content {
    .modal-body {
      .study-list {
        display: flex;
        flex-direction: column;
        border-right: 1px solid $charcoal;
        overflow-y: scroll;
        .study-wrapper {
          min-height: 44px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 0 8px;
          border-top: 1px dashed $charcoal;
          &:last-of-type {
            border-bottom: 1px dashed $charcoal;
          }

          .study-selection-checkbox {
            width: 100%;
          }
        }
      }
      .edit-form-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .form-row {
          width: 100%;
          .input-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            input {
              width: 100%;
            }
            .el-select {
              width: 100%;
            }
            label {
              color: $input-label;
              margin-bottom: 2px;
              margin-left: 2px;
              font-family: 'Source Sans Pro', sans-serif;
              font-size: 13px;
              line-height: 20px;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}

</style>
